import { render, staticRenderFns } from "./UnistarsIntroduction.vue?vue&type=template&id=13a4fda3&"
import script from "./UnistarsIntroduction.vue?vue&type=script&lang=js&"
export * from "./UnistarsIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports